export const UEEX_ORIGIN = "https://ueex.com";
export const DEFAULT_LOCALE = "en";

export const INTERNAL_LOCALES = [
  "en",
  "ja",
  "ko",
  "fr",
  "es",
  "ru",
  "de",
  "pt",
  "hi",
  "vi",
  "tl",
  "th",
  "tr",
  "it",
  "id",
  "ar",
  "zh_CN",
  "zh_HK",
];

export function toPublicLocale(locale) {
  return { zh_CN: "zh-CN", zh_HK: "zh-HK" }[locale] || locale;
}

export function toInternalLocale(locale) {
  return { "zh-CN": "zh_CN", "zh-HK": "zh_HK" }[locale] || locale;
}

export const PUBLIC_LOCALES = INTERNAL_LOCALES.map(toPublicLocale);
export const SEO_LOCALES = PUBLIC_LOCALES;
export const LOCALE_ROUTE_PATTERN = PUBLIC_LOCALES.join("|");

export const SEO_ROUTE_TYPE = {
  STATIC: "static",
  SYMBOL: "symbol",
};

export const SYMBOL_SEO_VALIDATION_EVENT = "route-symbol-seo-validation";

export function isSupportedLocale(locale) {
  return SEO_LOCALES.includes(locale);
}

export function isLegacyLocale(locale) {
  return ["zh_CN", "zh_HK"].includes(locale);
}

export function toLanguageTag(locale) {
  return toPublicLocale(locale);
}

export function createSymbolSeoValidation(route, valid) {
  return {
    routeName: route.name,
    path: route.path,
    symbol: route.params.symbol,
    valid,
  };
}
